import { MARK_HEIGHT, MARK_PATHS, MARK_WIDTH, markViewBox } from './markPaths'

export interface MarkProps {
  /** Rendered height in CSS units (number = px-equivalent via the `height` attribute; string as given). */
  size?: number | string
  /** The master files use 12, 14 and 18 depending on scale. */
  strokeWidth?: number
  title?: string
  className?: string
}

/**
 * The brand mark as inline SVG. Strokes are `currentColor`, so the sidebar sets it in
 * cream and a card sets it in Iron Black through CSS alone; nothing recolours the paths.
 */
export function Mark({ size = 32, strokeWidth = 14, title, className }: MarkProps) {
  const width = MARK_WIDTH + strokeWidth
  const height = MARK_HEIGHT + strokeWidth
  const ratio = width / height
  const h = typeof size === 'number' ? `${size}` : size
  const w = typeof size === 'number' ? `${Math.round(size * ratio * 100) / 100}` : undefined
  return (
    <svg
      viewBox={markViewBox(strokeWidth)}
      height={h}
      width={w}
      className={className}
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
    >
      {title && <title>{title}</title>}
      {MARK_PATHS.map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  )
}
